import React, { Component, KeyboardEvent, ReactNode, createRef, useEffect, useState } from 'react';
import { Input, Selector, Button, Tabs, SpinLoading } from 'antd-mobile';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
// @ts-ignore
import ViewSource, { ViewSourceType as Detail } from '@/components/ViewSource';
// @ts-ignore
import { Display } from '@/components/Display/Display';
import { cloneDeep } from 'lodash';
import 'react-photo-view/dist/react-photo-view.css';
import {
    aiDetail,
    fileDetail,
    updateTitle,
    getTranslation,
    getTranslationStatus,
    getDelete,
    Request,
    RequestResult
} from '../../../../../../api/fileManagement';
import s from './index.module.scss';
import { DownOutline, RightOutline } from 'antd-mobile-icons';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import person1 from '@/assets/images/tw/mobile/person1.webp';
import person2 from '@/assets/images/tw/mobile/person2.webp';
import person3 from '@/assets/images/tw/mobile/person3.webp';
import person4 from '@/assets/images/tw/mobile/person4.webp';
import emptyImg from '@/assets/images/mobile/empty.webp';
import ToastUtils from '@/utils/ToastUtils';
import { PhotoSlider } from 'react-photo-view';
import { languageOptionsInfo } from '../dict';
import { Markdown } from '@/components';
import ModalPopup from '@/components/Mobile/ModalPopup/ModalPopup';
import { fetchMarkdownDataByType } from '@/api/tingWu';
import GrtLoading from '@/components/Mobile/GrtLoading/GRTLoading';
import { getSearchStr } from '@/utils/Page';
const searchString = getSearchStr();
const defaultPerson: { [key: string]: string } = { '1': person1, '2': person2, '3': person3, '4': person4 };

interface DetailInherit extends Detail {
    chatbot_state?: 0 | 1;
    id?: any;
    local_source?: 0 | 1;
    ai_auth_state?: 0 | 1;
    source_id?: string;
    tenant_id?: string;
    name?: string;
    ai_translation_status?: string;
    target_languages?: string;
    type?: number;
}

interface DetailResult extends RequestResult {
    data: DetailInherit;
}

interface Props {
    sourceId: string;
    paramsInfo: any;
    navigate: any;
    searchParams: any;
}

type IconType = 'keyWord' | 'chapter' | 'summary' | 'ppt' | 'point' | 'speechesSummary' | '' | undefined;

type CommonDataItemType = {
    file_url?: string;
    start?: number; //ppt文件数据集
    summary?: string; //ppt文件数据集
    end?: number; //ppt文件数据集
    vid?: number; //ppt文件数据集
    sentence_id?: number; //智能纪要
    text?: string; //智能纪要
    headline?: string; //章节速览（自动章节）
    chapter_start_time?: number;
    chapter_id?: number;
    changed?: boolean;
    headlineChanged?: boolean;
    summaryChanged?: boolean;
    v_id?: number;
};
type TaskIdType = { TaskId?: string };

//智能纪要
type MeetingAssistanceDataType = {
    keywords?: string[];
    key_sentences?: CommonDataItemType[];
    classifications?: {
        Interview?: number;
        Lecture?: number;
        Meeting?: number;
    };
} & TaskIdType;
type ParagraphsItemType = {
    paragraph_id?: string;
    speaker_id?: string;
    words?: CommonDataItemType[]; //语音转写
    sentences?: CommonDataItemType[];
    start?: number;
    end?: number;
    indexSentenceId?: number;
    lastIndexSentenceId?: number;
};
//翻译
type TranslationDataType = {
    paragraphs?: ParagraphsItemType[];
} & TaskIdType;
//章节速览（自动章节）
type AutoChaptersDataType = CommonDataItemType[];
type AudioInfoType = {
    size?: number;
    duration?: number;
    sample_rate?: number;
};
//语音转写
type TranscriptionDataType = {
    audio_info?: AudioInfoType;
    paragraphs?: ParagraphsItemType[];
} & TaskIdType;
type ConversationalSummaryItemType = {
    speaker_id?: string;
    speaker_name?: string;
    summary?: string;
    vid?: string;
    changed?: boolean;
};
type QuestionsAnsweringSummaryItemType = {
    question?: string;
    sentence_ids_of_question?: number[];
    answer?: string;
    sentence_ids_of_answer?: number[];
    speaker_id?: string[];
    paragraph_id?: string;
    vid?: string;
    questionChanged?: boolean;
    answerChanged?: boolean;
};
type SummarizationDataType = {
    paragraph_summary?: string; //段落摘要
    conversational_summary_list?: ConversationalSummaryItemType[];
    questions_answering_summary_list?: QuestionsAnsweringSummaryItemType[];
} & TaskIdType;

export type AIDetailDataType = {
    data_type?: string;
    tr_id?: string;
    tenant_id?: string;
    resource_id?: string;
    task_id?: string;
    task_key?: string;
    mp3_path?: string;
    meeting_assistance?: MeetingAssistanceDataType;
    translation?: TranslationDataType;
    auto_chapters?: AutoChaptersDataType;
    transcription?: TranscriptionDataType;
    summarization?: SummarizationDataType;
    update_time?: string;
    roles_enabled?: boolean;
};

interface AiDetailResult extends RequestResult {
    data: AIDetailDataType;
}

type KeywordTypeItem = { index?: number; name?: string };
type KeywordType = {
    all: KeywordTypeItem[];
    del?: KeywordTypeItem[];
    add?: KeywordTypeItem[];
};

interface FormData {
    keyword: KeywordType;
    summary: string;
    conversational_summary_list: ConversationalSummaryItemType[];
    questions_answering_summary_list: QuestionsAnsweringSummaryItemType[];
    chapters: AutoChaptersDataType;
}

export enum Fade {
    In,
    Out
}

enum MDDataType {
    NULL,
    GOING,
    SUCCESS,
    FAIL
}

type QuestionsAnsweringSummaryMDDataType = {
    status?: MDDataType;
    content?: string;
};

interface State {
    show: boolean;
    detail: DetailInherit;
    id?: string;
    aiDetail: AIDetailDataType;
    tabItems: any[];
    meetingAssistance: MeetingAssistanceDataType;
    autoChapters: AutoChaptersDataType;
    summarization: SummarizationDataType;
    transcription: TranscriptionDataType;
    translation: TranslationDataType;
    questionsAnsweringSummaryType: OPTIONS_TYPE;
    questionsAnsweringSummaryMDData: QuestionsAnsweringSummaryMDDataType;
    currentTime?: number;
    lastSaveTime?: Date | number;
    paragraphId?: string;
    activeKey: string;
    activeCollapseKey: string;
    currKeyWord: string;
    playerOptions: any;
    clientOffSet: any;
    editTabType?: IconType;
    formData: FormData;
    fade?: Fade;
    spin?: boolean;
    scrollContentFlag?: boolean;
    photoImages: { src?: string; key?: string }[];
    showPhoto?: boolean;
    photoIndex?: number;
    questionsParams?: any;
    ishowBackTop?: any;
    isEditing?: boolean;
    titleData?: string;
    languageValue?: string;
    isTranslateShow?: boolean;
    isRealTime?: boolean;
    translateLoading?: boolean;
    translateStatus?: number;
    searchText?: string;
    isExpanded?: boolean;
    showAllKeywords?: boolean;
    keywordsOverflow?: boolean;
    showAllSummary?: boolean;
    showTranslateModal?: boolean;
    showStyleModal?: boolean;
    selectedStyle?: OPTIONS_TYPE;
    activeSummaryCollapseKey?: string;
    tempLanguageValue?: string;
}

type DEFAULT_ITEM_TITLE_TYPE = {
    [key in keyof AIDetailDataType]: { title: string; sort: number };
} & {
    [name in keyof SummarizationDataType]: { title: string; sort: number };
};
let DEFAULT_ITEM_TITLE: DEFAULT_ITEM_TITLE_TYPE = {
    auto_chapters: { title: '章节速览', sort: 0 },
    summarization: { title: '发言总结', sort: 1 },
    questions_answering_summary_list: { title: '要点回顾', sort: 2 },
};
enum OPTIONS_TYPE {
    Q_A_STYLE, //问答风格
    SIMPLE = 'minimal', //简洁
    DETAIL = 'detailed', //详细
    TUTORIAL = 'tutorial', //教程
    ACADEMIC = 'academic', //学术
    TASK_WIZARD = 'task_oriented', //任务向导
    MEETING_SUMMARY = 'meeting_minutes' //会议纪要
}

const DEFAULT_OPTIONS = [
    {
        value: OPTIONS_TYPE.Q_A_STYLE,
        label: '问答风格'
    },
    {
        value: OPTIONS_TYPE.SIMPLE,
        label: '精简'
    },
    {
        value: OPTIONS_TYPE.DETAIL,
        label: '详细'
    },
    {
        value: OPTIONS_TYPE.TUTORIAL,
        label: '教程'
    },
    {
        value: OPTIONS_TYPE.ACADEMIC,
        label: '学术'
    },
    {
        value: OPTIONS_TYPE.TASK_WIZARD,
        label: '任务导向'
    }
];
const DEFAULT_MIND_MAP_OPTIONS = cloneDeep(DEFAULT_OPTIONS).slice(1);
DEFAULT_MIND_MAP_OPTIONS.push({
    value: OPTIONS_TYPE.MEETING_SUMMARY,
    label: '会议纪要'
});
const img = {
    return_icon: require('@/assets/images/tw/mobile/return_icon.webp'),
    expand_icon: require('@/assets/images/tw/mobile/expand_icon.webp'),
    foldUp_icon: require('@/assets/images/tw/mobile/foldUp_icon.webp'),
    record_play: require('@/assets/images/record-play.gif'),
    datailtitle_icon: require('@/assets/images/tw/mobile/datailtitle_icon.webp'),
    search_icon: require('@/assets/images/tw/mobile/search_icon.webp'),
    point: require('@/assets/images/tw/mobile/point.webp'),
    topCurr_icon: require('@/assets/images/tw/mobile/topCurr_icon.webp'),
    titleAi_icon: require('@/assets/images/tw/mobile/titleAi-icon.webp'),
    translation_icon: require('@/assets/images/tw/mobile/translation_icon.webp'),
    translationCur_icon: require('@/assets/images/tw/mobile/translationCur_icon.webp'),
    aimOutlined_icon: require('@/assets/images/tw/mobile/aimOutlined_icon.webp'),
    circle_icon: require('@/assets/images/tw/mobile/circle_icon.webp')
}
class SourceDetailAI extends Component<Props, State> {
    interval: number | undefined;
    state: State = {
        show: false,
        detail: {},
        aiDetail: {},
        tabItems: [],
        activeKey: 'summary',
        meetingAssistance: {},
        questionsAnsweringSummaryType: OPTIONS_TYPE.Q_A_STYLE,
        questionsAnsweringSummaryMDData: {},
        autoChapters: [],
        summarization: {},
        transcription: {},
        translation: {},
        playerOptions: {},
        currKeyWord: '',
        activeCollapseKey: '1',
        clientOffSet: {},
        formData: {
            keyword: { all: [] },
            summary: '',
            conversational_summary_list: [],
            questions_answering_summary_list: [],
            chapters: []
        },
        fade: Fade.Out,
        spin: true,
        scrollContentFlag: true,
        photoImages: [],
        showPhoto: false,
        photoIndex: 0,
        questionsParams: {
            id: this.props.sourceId
        },
        ishowBackTop: 0,
        isEditing: false,
        titleData: '',
        languageValue: 'no',
        isTranslateShow: false,
        translateLoading: false,
        translateStatus: 2,
        searchText: '',
        isExpanded: false,
        showAllKeywords: false,
        keywordsOverflow: false,
        showAllSummary: false,
        showTranslateModal: false,
        showStyleModal: false,
        selectedStyle: OPTIONS_TYPE.Q_A_STYLE,
        activeSummaryCollapseKey: '1',
        tempLanguageValue: 'no'
    };
    courseRef: any = null;
    inputRef = createRef<HTMLInputElement>();
    keywordsContainerRef = createRef<HTMLDivElement>();
    selectSummaryTimer: number | null = null;

    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (nextProps.sourceId && nextProps.sourceId !== prevState.id) {
            prevState.id = nextProps.sourceId;
            return prevState;
        }
        return null;
    }

    async getTranslationStatusFun(): Promise<DetailResult> {
        return Request.get(Request.baseUrl + getTranslationStatus + '?document_id=' + this.props.sourceId);
    }

    async fetchDetailData(): Promise<DetailResult> {
        return Request.get(Request.baseUrl + fileDetail + '?document_id=' + this.props.sourceId);
    }

    async fetchAIDetail(): Promise<AiDetailResult> {
        const data: AIDetailDataType = await Request.get(Request.baseUrl + aiDetail + '?resource_id=' + this.props.sourceId);
        return { data, success: true, code: '200', msg: '' };
    }

    fetchData() {
        Promise.all([this.fetchDetailData(), this.fetchAIDetail(), this.getTranslationStatusFun()]).then((res) => {
            const [sourceDetailResult, aiDetailResult, translationStatus] = res;
            let detail: Detail = {},
                aiDetail: AIDetailDataType = {};
            if (sourceDetailResult.success) {
                const { data } = sourceDetailResult;
                detail = data;
            } else {
                ToastUtils.showToast(sourceDetailResult.msg || '服务请求发生错误');
            }
            if (aiDetailResult.success) {
                const { data } = aiDetailResult;
                aiDetail = data;
            }
            if (translationStatus.success) {
                this.setState(
                    {
                        translateStatus: Number(translationStatus?.data?.ai_translation_status),
                        languageValue: translationStatus?.data?.target_languages
                    },
                    () => {
                        if (this.state.translateStatus === 1) {
                            this.startTranslationStatusCheck();
                        }
                    }
                );
            }
            const playerOptions: any = {
                height: 215,
                fluid: false
            },
                progressDot: any[] = [],
                autoChapters = aiDetail?.auto_chapters || [];
            if (autoChapters?.length) {
                for (const chapter of autoChapters) {
                    if (chapter?.v_id) {
                        let start = (chapter.start as number) / 1000,
                            duration = ((chapter.end as number) - (chapter.start as number)) / 1000;
                        progressDot.push({
                            time: start,
                            text: chapter.headline,
                            duration: duration
                        });
                    }
                }
                playerOptions.progressDot = progressDot;
            }
            this.setState(
                {
                    detail,
                    spin: false,
                    aiDetail,
                    isRealTime: aiDetail?.data_type === 'realtime',
                    playerOptions,
                    titleData: detail.name
                },
                () => {
                    this.fetchTabInfo();
                    this.initDataHandle();
                }
            );
        });
    }

    initAIDataHandle() {
        let aiDetail: AIDetailDataType = {};
        this.fetchAIDetail().then((aiDetailResult) => {
            if (aiDetailResult.success) {
                const { data } = aiDetailResult;
                aiDetail = data;
            } else return;
            this.setState({ aiDetail }, () => {
                this.fetchTabInfo();
                this.initDataHandle();
            });
        });
    }

    initDataHandle() {
        let result = this.state.aiDetail,
            meetingAssistance = result?.meeting_assistance || {},
            autoChapters = result?.auto_chapters || [],
            summarization = result?.summarization || {},
            transcription = result?.transcription || {},
            translation = result?.translation || {},
            photoImages: any[] = [],
            formData: FormData = {
                keyword: { all: [] },
                summary: summarization?.paragraph_summary || '',
                conversational_summary_list: cloneDeep(summarization?.conversational_summary_list || []),
                questions_answering_summary_list: [],
                chapters: cloneDeep(autoChapters)
            };
        if (meetingAssistance?.keywords && meetingAssistance?.keywords?.length) {
            const all = formData?.keyword?.all;
            meetingAssistance?.keywords?.forEach((item, index) => {
                all.push({ name: item, index });
            });
        }
        if (Object.keys(transcription).length && transcription?.paragraphs?.length) {
            const paragraphs = transcription?.paragraphs;
            for (const paragraph of paragraphs) {
                const words = paragraph?.words;
                if (words?.length) {
                    paragraph.start = words[0]?.start;
                    paragraph.end = words[words?.length - 1]?.end;
                    const index = words.findIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.indexSentenceId = words[index]['sentence_id'];
                    //@ts-ignore
                    const lastIndex = words.findLastIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.lastIndexSentenceId = words[lastIndex]['sentence_id'];
                }
            }
            transcription.paragraphs = paragraphs;
        }
        if (Object.keys(translation).length && translation?.paragraphs?.length) {
            const paragraphs = translation?.paragraphs;
            for (const paragraph of paragraphs) {
                const words = paragraph?.words;
                if (words?.length) {
                    paragraph.start = words[0]?.start;
                    paragraph.end = words[words?.length - 1]?.end;
                    const index = words.findIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.indexSentenceId = words[index]['sentence_id'];
                    //@ts-ignore
                    const lastIndex = words.findLastIndex((item) => item && item.hasOwnProperty('sentence_id'));
                    paragraph.lastIndexSentenceId = words[lastIndex]['sentence_id'];
                }
            }
            translation.paragraphs = paragraphs;
        }
        if (summarization?.questions_answering_summary_list?.length) {
            const questionsAnsweringSummary = summarization?.questions_answering_summary_list;
            for (const questionsAnsweringSummaryElement of questionsAnsweringSummary) {
                if (questionsAnsweringSummaryElement?.sentence_ids_of_answer?.length) {
                    const start: number = questionsAnsweringSummaryElement?.sentence_ids_of_answer[0],
                        paragraphs = transcription?.paragraphs;
                    questionsAnsweringSummaryElement.speaker_id = [];
                    if (paragraphs?.length) {
                        for (const paragraph of paragraphs) {
                            if (
                                start &&
                                start >= (paragraph?.indexSentenceId as number) &&
                                start &&
                                start <= (paragraph?.lastIndexSentenceId as number)
                            ) {
                                questionsAnsweringSummaryElement.speaker_id.push(paragraph.speaker_id as string);
                                if (!questionsAnsweringSummaryElement?.paragraph_id && paragraph.paragraph_id)
                                    questionsAnsweringSummaryElement.paragraph_id = paragraph.paragraph_id;
                            }
                        }
                        questionsAnsweringSummaryElement.speaker_id = Array.from(new Set(questionsAnsweringSummaryElement.speaker_id));
                    }
                }
            }
            formData.questions_answering_summary_list = cloneDeep(summarization?.questions_answering_summary_list || []);
        }
        this.setState({
            formData,
            meetingAssistance,
            autoChapters,
            summarization,
            transcription,
            translation,
            photoImages
        });
    }

    fetchTabInfo() {
        const aiDetail = this.state.aiDetail;
        const resultKeys = Object.keys(aiDetail),
            resultValues = Object.values(aiDetail),
            tabItems: any[] = [];
        if (resultKeys.length) {
            for (let i = 0, len = resultKeys.length; i < len; i++) {
                const item = resultKeys[i],
                    index = i,
                    //@ts-ignore
                    ite = DEFAULT_ITEM_TITLE[item];
                if (ite && resultValues[index]) {
                    if (resultValues[index].hasOwnProperty('questions_answering_summary_list')) {
                        tabItems.push({
                            key: 'questions_answering_summary_list',
                            //@ts-ignore
                            label: DEFAULT_ITEM_TITLE.questions_answering_summary_list['title'],
                            //@ts-ignore
                            sort: DEFAULT_ITEM_TITLE.questions_answering_summary_list['sort'],
                            type: 'questions_answering_summary_list'
                        });
                    }
                    tabItems.push({
                        key: item,
                        label: ite.title,
                        //@ts-ignore
                        sort: ite.sort,
                        type: item
                    });
                }
            }
        }
        if (tabItems.length) {
            //@ts-ignore
            const sortTabItems = tabItems.sort((curr, next) => curr.sort - next.sort);
            this.setState({ tabItems: sortTabItems });
        }
    }

    componentDidMount() {
        this.fetchData();
        // 组件挂载后，检查关键词是否溢出
        setTimeout(this.checkKeywordsOverflow, 0);
    }
    // 动态获取【当前显示的原文 Tab 滚动容器】
    getActiveScrollEl = () => {
        const scrollEls: any = document.querySelectorAll('.adm-tabs-content');
        // 遍历找到 visible=true 的容器
        for (let i = 0; i < scrollEls.length; i++) {
            const el = scrollEls[i];
            if (el.offsetParent !== null) { // 元素可见
                return el;
            }
        }
        return null;
    };
    // 滚动事件：只监听原文区域滚动
    handleContentScroll = () => {
        const scrollEl = this.getActiveScrollEl();
        if (scrollEl) {
            this.setState({
                ishowBackTop: scrollEl.scrollTop
            });
        }
    };

    onTabClickHandle(key: string) {
        this.setState({ activeKey: key });
    }

    nowTimeFu(milliseconds: number) {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        return hours
            ? `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`
            : `${this.padZero(minutes)}:${this.padZero(seconds)}`;
    }

    padZero(value: number) {
        return String(value).padStart(2, '0');
    }

    getSpeakerNameById(id: string) {
        const conversationalSummary = this.state.summarization?.conversational_summary_list;
        if (conversationalSummary?.length) {
            for (const item of conversationalSummary) {
                if (item['speaker_id'] && item['speaker_id'] === id) {
                    return item.speaker_name;
                }
            }
        }
        return null;
    }

    redirectChapter(data: CommonDataItemType) {
        if (this.state.editTabType === 'chapter') return;
        const start: number = data.start as number,
            currentTime = (data.start as number) / 1000,
            paragraphs = this.state.transcription?.paragraphs;
        this.setState({ currentTime }, () => {
            this.courseRef.currentTime = currentTime;
            let paragraphs_id: string = '';
            if (paragraphs && paragraphs?.length) {
                for (const paragraph of paragraphs) {
                    if (paragraph.start && start >= paragraph.start) {
                        paragraphs_id = paragraph.paragraph_id as string;
                        break;
                    }
                }
            }
            if (paragraphs_id) {
                const target = document.querySelector('div[data-paragraph-id="' + paragraphs_id + '"]');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });
    }

    viewChapter(key: string) {
        this.setState({ activeCollapseKey: key === '0' ? '1' : key === '1' ? '0' : '' });
    }

    viewSummary(key: string) {
        this.setState({ activeSummaryCollapseKey: key === '0' ? '1' : key === '1' ? '0' : '' });
    }

    retrospectiveHandle(item: CommonDataItemType) {
        const start: number = item.start as number,
            currentTime = (item.start as number) / 1000;
        this.setState({ currentTime }, () => {
            this.courseRef.currentTime = currentTime;
            this.courseRef?.play();
            const paragraphs = this.state.transcription?.paragraphs;
            let paragraphs_id = '';
            if (paragraphs?.length) {
                for (const paragraph of paragraphs) {
                    if (paragraph.start && start >= paragraph.start) {
                        paragraphs_id = paragraph.paragraph_id as string;
                        break;
                    }
                }
            }
            if (paragraphs_id) {
                const target = document.querySelector('div[data-paragraph-id="' + paragraphs_id + '"]');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        });
    }

    renderAutoChapters() {
        const result: ReactNode[] = [],
            formData = this.state.formData,
            chapter = formData?.chapters;
        chapter?.forEach((item) => {
            result.push(

                <div
                    key={item?.v_id}
                    className={s['chapter-collapse']}
                    onClick={() => {
                        this.redirectChapter(item);
                        this.retrospectiveHandle(item);
                    }}
                >
                    <div className={s['chapter-collapse-time']}><img src={img.circle_icon} alt="" />{this.nowTimeFu(item.start ?? 0)}</div>
                    <div
                        className={s['ai-panel-header']}
                        data-id={item.v_id}
                    >
                        <div
                            className={s['ai-panel-header-title']}
                            dangerouslySetInnerHTML={{ __html: this.replaceEnter2Br(item.headline as string) }}
                        />
                    </div>
                    <div
                        className={s['ai-panel-header-lTitle']}
                        dangerouslySetInnerHTML={{ __html: this.replaceEnter2Br(item.summary as string) }}
                    />
                </div>
            );
        });
        const resultItems = this.state.activeCollapseKey === '0' ? result : result && result?.length > 2 ? result.slice(0, 2) : result;
        return (
            <div className={s['timeline_container']}>
                {result && result.length ? (
                    <div>
                        <div>{resultItems}</div>
                    </div>
                ) : null}
            </div>
        );
    }

    fetchQuestionsAndAnswerMDData(type: OPTIONS_TYPE) {
        const handle = () =>
            fetchMarkdownDataByType(this.state.aiDetail.resource_id, type).then((res: any) => {
                const { success, data, msg } = res;
                if (success) {
                    const questionsAnsweringSummaryMDData = data;
                    if (data && data.status === MDDataType.SUCCESS) clearInterval(this.selectSummaryTimer as number);
                    this.setState({ questionsAnsweringSummaryMDData });
                } else {
                    ToastUtils.showToast(msg || '服务请求发生错误');
                    const questionsAnsweringSummaryMDData = { status: MDDataType.FAIL, content: '' };
                    clearInterval(this.selectSummaryTimer as number);
                    this.setState({ questionsAnsweringSummaryMDData });
                }
            });
        handle();
        this.selectSummaryTimer = window.setInterval(handle, 1000);
    }

    changeSelectSummary(value: OPTIONS_TYPE) {
        this.setState({ questionsAnsweringSummaryType: value }, () => {
            clearInterval(this.selectSummaryTimer as number);
            if (value !== OPTIONS_TYPE.Q_A_STYLE) {
                this.fetchQuestionsAndAnswerMDData(value);
            }
        });
    }
    renderSummarization() {
        const conversationalSummary =
            this.state.formData?.conversational_summary_list && this.state.formData?.conversational_summary_list?.length
                ? this.state.formData?.conversational_summary_list.sort((a, b) => {
                    return Number(a.speaker_id) - Number(b.speaker_id);
                })
                : this.state.formData?.conversational_summary_list,
            result: ReactNode[] = [];
        if (conversationalSummary?.length) {
            conversationalSummary.forEach((item) => {
                result.push(
                    <div
                        data-summary-item-id={item.vid}
                        className={s['ai-summary-container-item']}
                        key={item?.speaker_id}
                    >
                        <div className={s['ai-summary-container-item-speaker']}>{this.getReviewSpeakerName(item?.speaker_id as string)}</div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className={s['ai-summary-container-item-summary']}>{item.summary}</div>
                        </div>
                    </div>
                );
            });
            const resultItems = this.state.activeSummaryCollapseKey === '0' ? result : result && result?.length > 2 ? result.slice(0, 2) : result;
            return (
                <div className={s['ai-summary-container']}>
                    <div className={s['ai-key-word-header']}>
                        <div className={s['ai-title']}><img src={img.datailtitle_icon} />发言总结</div>
                        {result.length > 2 && (
                            <div
                                className={s['ai-title-right']}
                                onClick={() => this.viewSummary(this.state.activeSummaryCollapseKey || '')}
                            >
                                {this.state.activeSummaryCollapseKey === '0' ? <DownOutline style={{ fontSize: '14px', color: '#999999' }} /> : <RightOutline style={{ fontSize: '14px', color: '#999999' }} />}
                            </div>
                        )}
                    </div>
                    {resultItems}
                </div>
            );
        }
        return null;
    }

    renderQuestionsAnsweringSummary() {
        const questionsAnsweringSummary = this.state.formData?.questions_answering_summary_list,
            result: ReactNode[] = [];
        if (questionsAnsweringSummary?.length) {
            questionsAnsweringSummary.forEach((item) => {
                result.push(
                    <div
                        data-ai-summary-review-id={item.vid}
                        className={s['ai-summary-container-item-review']}
                        key={item?.question}
                    >
                        <img className={s['ai-summary-point-icon']} src={img.point} alt={'要点'} />
                        <div
                            className={s['ai-summary-point-content']}
                            onClick={() => this.speechesSummaryScroll2View(item, this.state.editTabType)}
                        >
                            <div
                                className={s['ai-summary-container-item-review-question']}
                                dangerouslySetInnerHTML={{ __html: item?.question as string }}
                            ></div>
                            <div
                                className={s['ai-summary-container-item-review-answer']}
                                dangerouslySetInnerHTML={{ __html: item?.answer as string }}
                            ></div>

                        </div>
                    </div>
                );
            });
            return (
                <div className={`${s['ai-summary-container']} ${s['new']}`}>
                    <div>
                        <ModalPopup
                            visible={this.state.showStyleModal || false}
                            title="选择风格"
                            onClose={() => this.setState({ showStyleModal: false })}
                        >
                            <div className={s['selector-lsit']}>
                                <Selector
                                    showCheckMark={false}
                                    columns={1}
                                    value={[this.state.selectedStyle || 0]}
                                    // @ts-ignore
                                    onChange={(val) => val.length && this.setState({ selectedStyle: val[0] as number | string })}
                                    options={DEFAULT_OPTIONS}
                                    multiple={false}
                                    disabled={false}
                                />
                            </div>
                            <div className={s['btn-css']}>
                                <Button size='small' color='primary' className={s['btn-primary']}
                                    onClick={() => {
                                        if (this.state.selectedStyle !== undefined) {
                                            this.changeSelectSummary(this.state.selectedStyle);
                                            this.setState({ showStyleModal: false });
                                        }
                                    }}
                                >
                                    确定
                                </Button>
                            </div>
                        </ModalPopup>
                    </div>
                    {this.state.questionsAnsweringSummaryType === OPTIONS_TYPE.Q_A_STYLE ? result : this.renderQuestionsAnsweringSummaryOtherType()}
                </div>
            );
        }
        return null;
    }


    renderQuestionsAnsweringSummaryOtherType() {
        if (this.state.questionsAnsweringSummaryMDData?.status === MDDataType.GOING) {
            return (
                <div className={s['ai-paragraph-item-content']}>
                    <div
                        className={s['ai-paragraph-tranIng']}
                        style={{
                            border: 'none',
                            padding: '8px 0'
                        }}
                    >
                        正在整理内容...
                    </div>
                </div>
            );
        } else if (this.state.questionsAnsweringSummaryMDData?.status === MDDataType.SUCCESS) {
            return <Markdown className={s['render-md']} content={this.state.questionsAnsweringSummaryMDData.content || ''} />;
        } else if (this.state.questionsAnsweringSummaryMDData?.status === MDDataType.FAIL) {
            return (
                <div className={s['ai-paragraph-item-content']}>
                    <div
                        className={s['ai-paragraph-tranFeil']}
                        style={{
                            border: 'none',
                            padding: '8px 0'
                        }}
                    >
                        转录失败了，再试一次吧～
                    </div>
                </div>
            );
        }
        return '';
    }

    speechesSummaryScroll2View(data: QuestionsAnsweringSummaryItemType, isEdit: any) {
        if (isEdit === 'speechesSummary') return;
        this.setState({ paragraphId: data?.paragraph_id }, () => {
            this.scroll2View();
        });
    }

    getActiveContent() {
        const tabItems = this.state.tabItems,
            activeKey = this.state.activeKey;
        if (tabItems?.length) {
            let type = '';
            tabItems.forEach((item) => {
                //@ts-ignore
                if (item.key === activeKey) type = item.type;
            });
            if (type === 'auto_chapters') return this.renderAutoChapters();
            else if (type === 'summarization') return this.renderSummarization();
            else if (type === 'questions_answering_summary_list') return this.renderQuestionsAnsweringSummary();
        }
        return null;
    }

    getReviewSpeakerName(speakerIds: string[] | string) {
        const result: ReactNode[] = [];
        let index = 1;
        if (!Array.isArray(speakerIds)) speakerIds = [speakerIds];
        speakerIds?.map((item) => {
            if (index > 4) index = 1;
            if (this.state.aiDetail?.roles_enabled) {
                //@ts-ignore
                result.push(
                    <div key={defaultPerson['item'] ? defaultPerson[item] : defaultPerson[String(index)]} className={s['point-speaker-item']}>
                        <img width={25} src={defaultPerson[item] ? defaultPerson[String(item)] : defaultPerson[String(index)]} alt={''} />
                        <span>{this.getSpeakerNameById(item)}</span>
                    </div>
                );
            } else
                result.push(
                    <div key={defaultPerson[item] ? defaultPerson[item] : defaultPerson[String(index)]} className={s['point-speaker-item']}></div>
                );
            index++;
        });
        return result;
    }

    replaceEnter2Br(str: string) {
        return str ? str.replace(/\n/g, '<br>') : '';
    }

    toggleShowAllKeywords = () => {
        this.setState({ showAllKeywords: !this.state.showAllKeywords });
    };

    checkKeywordsOverflow = () => {
        if (this.keywordsContainerRef.current) {
            const container = this.keywordsContainerRef.current;
            container.style.overflow = 'hidden';
            container.style.height = '25px';
            // 用 actualHeight / scrollHeight 对比
            const actualHeight = container.getBoundingClientRect().height;
            const realScrollHeight = container.scrollHeight;
            // 只要内容高度 > 容器实际高度，就显示箭头
            const shouldShowArrow = realScrollHeight > actualHeight + 10;

            this.setState({ keywordsOverflow: shouldShowArrow });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.formData?.keyword?.all !== this.state.formData?.keyword?.all) {
            // 关键词数据变化时，检查是否溢出
            setTimeout(this.checkKeywordsOverflow, 0);
        }
    }

    getKeyWords(): ReactNode {
        const keyWords = this.state.formData?.keyword,
            all = keyWords?.all,
            result: ReactNode[] = [];
        if (all?.length) {
            all.map((item) => {
                result.push(
                    <span className={s['key-words-item']} key={item.index} onClick={() => this.clickKeyWords(item.name as string)}>
                        {item.name}
                    </span>
                );
            });

            return (
                <div
                    ref={this.keywordsContainerRef}
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        height: this.state.showAllKeywords ? 'auto' : '25px',
                        overflow: this.state.showAllKeywords ? 'visible' : 'hidden'
                    }}
                >{result}</div>
            );
        }
        return null;
    }

    getSummary(): ReactNode {
        const summary = this.state.summarization;
        const content = summary?.paragraph_summary || '';
        const maxLength = 55;

        // 截取文本，超过65字显示...
        const truncatedContent = content.length > maxLength ? content.substring(0, maxLength) + '...' : content;

        return (
            <div className={s['ai-summary-content']}>
                <span
                    style={{
                        fontWeight: 400,
                        fontSize: 14,
                        color: '#666666'
                    }}
                >
                    {this.state.showAllSummary ? content : truncatedContent}
                </span>
            </div>
        );
    }

    clickEditorHandle() {
        const sel = window.getSelection();
        if (sel) {
            const node = sel.focusNode || sel.anchorNode;
            if (node && node.parentElement) {
                const time = node.parentElement.getAttribute('data-time');
                if (time) {
                    let currentTime = Number(time) / 1000;
                    this.setState({ currentTime }, () => {
                        this.courseRef.currentTime = currentTime;
                    });
                }
            }
        }
    }

    getAllContent(): ReactNode {
        const transcription = this.state.transcription,
            auto_chapter = this.state.formData?.chapters,
            paragraphs = transcription?.paragraphs;
        const translation = this.state.translation,
            paragraphstranslation = translation?.paragraphs;
        if (!paragraphs?.length)
            return (
                // <div className={s['ai-paragraph-item-content']}>
                //     <div className={s['ai-paragraph-tranIng']} style={{ border: 'none', padding: '8px 0' }}>
                //         似乎没有获取到有关信息        
                //     </div>
                // </div>
                <div className={s['status-div']}>
                    <img src={emptyImg} />
                    <div className={s['status-text']}>
                        抱歉，暂无数据～
                    </div>
                </div>
            );
        //@ts-ignore
        let paragraphsArr: (ParagraphsItemType & { text?: string })[];
        //@ts-ignore
        if (paragraphs?.length && paragraphstranslation?.length) {
            paragraphsArr = paragraphs.map((firstItem) => {
                //@ts-ignore
                const match = paragraphstranslation.find((secondItem) => secondItem.paragraph_id === firstItem.paragraph_id);
                if (match) {
                    //@ts-ignore
                    const texts = match.sentences.map((sentence) => sentence.text).join(' ');
                    return { ...firstItem, text: texts };
                }
                return firstItem;
            });
        } else {
            //@ts-ignore
            paragraphsArr = paragraphs;
        }
        //@ts-ignore
        if (paragraphsArr?.length) {
            const result: ReactNode[] = [],
                chapterMap: Map<number, any> = new Map();
            paragraphsArr.forEach((item, index) => {
                const paragraphId = item.paragraph_id,
                    speakerId = item.speaker_id,
                    words = item.words,
                    start = item.start,
                    end = item.end,
                    //@ts-ignore
                    text = item.text;
                if (auto_chapter?.length && start) {
                    const chapterIndex = auto_chapter.findIndex((chapter) => {
                        return (chapter?.start as number) <= start && (chapter?.end as number) >= Number(end);
                    });
                    if (chapterMap.get(chapterIndex)) {
                        const value = chapterMap.get(chapterIndex);
                        value.push(index);
                    } else chapterMap.set(chapterIndex, [index]);
                }
                if (words?.length) {
                    let wordsDir: ReactNode[] = [],
                        start: number = 0;
                    for (let i = 0, len = words.length; i < len; i++) {
                        const ite = words[i];
                        if (i === 0) start = ite.start as number;
                        if (paragraphId === this.state.paragraphId && (ite.start as number) <= (this.state.currentTime || 0) * 1000) {
                            wordsDir.push(
                                <span
                                    data-time={ite.start}
                                    data-time-range={ite.start + '-' + ite.end}
                                    data-sentence-id={ite.sentence_id}
                                    data-id={ite.v_id}
                                    className={s['payload']}
                                    key={ite.v_id}
                                >
                                    {ite.text && ite.text === this.state.currKeyWord ? (
                                        <span className={s['searched'] + ' ' + s['active']}>{ite.text}</span>
                                    ) : (
                                        ite.text
                                    )}
                                </span>
                            );
                        } else
                            wordsDir.push(
                                <span
                                    data-time={ite.start}
                                    data-time-range={ite.start + '-' + ite.end}
                                    data-sentence-id={ite.sentence_id}
                                    data-id={ite.v_id}
                                    key={ite.v_id}
                                >
                                    {ite.text && ite.text === this.state.currKeyWord ? (
                                        <span className={s['searched'] + ' ' + s['active']}>{ite.text}</span>
                                    ) : (
                                        ite.text
                                    )}
                                </span>
                            );
                    }
                    result.push(
                        <div
                            className={s['ai-paragraph-item']}
                            data-speaker-id={item.speaker_id}
                            data-paragraph-id={paragraphId}
                            id={String(start)}
                            key={paragraphId}
                        >
                            <div className={s['ai-paragraph-item-header']}>
                                {this.getReviewSpeakerName(speakerId as string)}
                                <span className={s['ai-paragraph-item-header-time']}>{this.nowTimeFu(start ?? 0)}</span>
                            </div>
                            <div className={s['ai-paragraph-item-content'] + (paragraphId === this.state.paragraphId ? ' ' + s['active-paragraphOther'] : '')}>
                                <div
                                    className={s['ai-paragraph-editor']}
                                    data-paragraph-id={paragraphId}
                                    data-speaker-id={speakerId}
                                    onClick={this.clickEditorHandle.bind(this)}
                                >
                                    {wordsDir}
                                </div>
                                {this.state.languageValue === 'no' ? null : this.state.translateStatus === 2 ? (
                                    <div className={s['ai-paragraph-tran']}>{text}</div>
                                ) : this.state.translateStatus === 1 ? (
                                    <div className={s['ai-paragraph-tranIng']}>加载中...</div>
                                ) : this.state.translateStatus === 3 ? (
                                    <div className={s['ai-paragraph-tranFeil']}>翻译失败</div>
                                ) : null}
                            </div>
                        </div>
                    );
                } else {
                    result.push(
                        <div
                            className={s['ai-paragraph-item']}
                            data-speaker-id={item.speaker_id}
                            data-paragraph-id={paragraphId}
                            id={String(start)}
                            key={paragraphId}
                        >
                            <div className={s['ai-paragraph-item-header']}>
                                {this.getReviewSpeakerName(speakerId as string)}
                                <span className={s['ai-paragraph-item-header-time']}>{this.nowTimeFu(start ?? 0)}</span>
                            </div>
                            <div className={s['ai-paragraph-item-content'] + (paragraphId === this.state.paragraphId ? ' ' + s['active-paragraphOther'] : '')}>
                                <div
                                    className={s['ai-paragraph-editor']}
                                    data-paragraph-id={paragraphId}
                                    data-speaker-id={speakerId}
                                    onClick={this.clickEditorHandle.bind(this)}
                                ></div>
                                <div></div>
                            </div>
                        </div>
                    );
                }
            });
            return (
                <div className={s['timeline_container']}>
                    {result.map((short, index) => (
                        <div key={index} className={s['steps-item-wrapper']}>
                            <div className={s['steps-item-content']}>{short}</div>
                        </div>
                    ))}
                </div>
            );
        }
        return null;
    }

    scroll2View() {
        const paragraphId = this.state.paragraphId,
            target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

    scroll2Top() {
        // 获取所有 Tab 内容区，取第二个（原文 Tab）
        const scrollEls = document.querySelectorAll('.adm-tabs-content');
        const scrollEl = scrollEls[1]; // 第二个才是原文
        if (scrollEl) {
            scrollEl.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    clickKeyWords(keyWords: string) {
        const punctuationRegex = /[\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u300a\u300b\u2018\u2019\uff1f\uff01.,:;'"()?!]/g;
        let keyWord = keyWords;
        let transcription = cloneDeep(this.state.transcription),
            paragraphs = transcription.paragraphs;
        let paragraphId: string = '';
        let flagOther = false;
        if (paragraphs?.length) {
            for (const paragraph of paragraphs) {
                let words = paragraph.words,
                    flag: boolean = false;

                if (words?.length) {
                    let continueFlag = false,
                        continueArray: number[] = [];
                    for (let i = 0, len = words.length; i < len; i++) {
                        const word = words[i];
                        let wordOther = word.text as string;
                        if (word && word.text && word.text === keyWord) {
                            if (!flag) {
                                if (!flagOther) {
                                    paragraphId = paragraph.paragraph_id || '';
                                }
                                flag = true;
                                flagOther = true;
                            }
                            continueFlag = false;
                            continueArray = [];
                        } else if (keyWord.indexOf(wordOther) !== -1) {
                            continueFlag = true;
                            continueArray.push(i);
                        } else if (word && punctuationRegex.test(wordOther) && keyWord.indexOf(wordOther.replace(punctuationRegex, '')) !== -1) {
                            const match = wordOther.match(punctuationRegex);
                            if (match && match.length) {
                                continueFlag = true;
                                continueArray.push(i);
                            }
                        } else if (wordOther.includes(keyWord)) {
                            continueFlag = true;
                            continueArray.push(i);
                        } else {
                            continueFlag = false;
                            continueArray = [];
                        }
                        if (continueFlag && continueArray.length) {
                            const newKeyWordArr = continueArray.map((item) => words && words[item]?.text),
                                newWords = newKeyWordArr && newKeyWordArr.length ? newKeyWordArr.join('') : '',
                                replaceKeyword = newWords.replace(punctuationRegex, '');
                            if (replaceKeyword && replaceKeyword === keyWord) {
                                if (!flag) {
                                    if (!paragraphId) {
                                        paragraphId = paragraph.paragraph_id || '';
                                    }
                                    flag = true;
                                    flagOther = true;
                                }
                                if (replaceKeyword !== newWords) {
                                    const match = wordOther.match(punctuationRegex);
                                    if (match?.length) {
                                        const index = wordOther.indexOf(match[0]);
                                        if (index === 0) {
                                            word.text = word?.text?.replace(punctuationRegex, '');
                                            words?.splice(
                                                i - 1,
                                                0,
                                                Object.assign({}, word, {
                                                    text: match[0],
                                                    vid: Number(word?.vid) - 1
                                                })
                                            );
                                        } else if (index === wordOther.length - 1) {
                                            word.text = word?.text?.replace(punctuationRegex, '');
                                            words?.splice(
                                                i + 1,
                                                0,
                                                Object.assign({}, word, {
                                                    text: match[0],
                                                    vid: Number(word?.vid) + 1
                                                })
                                            );
                                        }
                                    }
                                } else {
                                    words.splice(continueArray[0], continueArray.length, {
                                        sentence_id: words[continueArray[0]]?.sentence_id,
                                        start: words[continueArray[0]]?.start,
                                        end: words[continueArray[continueArray.length - 1]]?.end,
                                        text: replaceKeyword,
                                        vid: words[continueArray[0]]?.vid
                                    });
                                }
                                i -= continueArray.length;
                                len -= continueArray.length;
                                continueFlag = false;
                                continueArray = [];
                                flag = false;
                            } else if (replaceKeyword.includes(keyWord)) {
                                let parts = replaceKeyword.split(keyWord);
                                let result: string[] = [];
                                for (let i = 0; i < parts.length; i++) {
                                    result.push(parts[i]);
                                    if (i < parts.length - 1 || parts[i] !== '') {
                                        result.push(keyWord);
                                    }
                                }
                                if (parts[parts.length - 1] === '') {
                                    result.pop();
                                }
                                result = result.filter((part) => part !== '');
                                if (result.length) {
                                    const startIndex = continueArray[0];
                                    const currentVid = Number(words[startIndex]?.vid) || 0;
                                    const newWordsArray = result.map((text, index) => ({
                                        text,
                                        vid: currentVid + index
                                    }));
                                    words.splice(startIndex, continueArray.length, ...newWordsArray);
                                    i -= continueArray.length;
                                    len -= continueArray.length;
                                    continueFlag = false;
                                    continueArray = [];
                                    flag = false;
                                }
                            }
                        }
                    }
                }
            }
        }
        this.setState({ currKeyWord: keyWord, activeKey: 'summaryAll' }, () => {
            if (paragraphId) {
                const target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });
    }

    registerPlayerMethod(player: any) {
        this.courseRef = player;
        //音频播放器增加样式
        const style = document.createElement('style');
        style.textContent = `.xgplayer-customAudiobackground { pointer-events: none; }`;
        document.head.appendChild(style);
        const playTime = this.props.searchParams?.get('t');
        if (playTime) this.courseRef.currentTime = Number(playTime);
        player.onTimeUpdate = () => {
            const currentTime: number = player.currentTime,
                transcription = this.state.transcription;
            let paragraphId: string = '';
            if (transcription && transcription?.paragraphs && transcription?.paragraphs?.length) {
                const paragraphs = transcription?.paragraphs;
                for (const paragraph of paragraphs) {
                    if ((paragraph.start as number) <= currentTime * 1000 && (paragraph.end as number) >= currentTime * 1000) {
                        paragraphId = paragraph.paragraph_id || '';
                        break;
                    }
                }
                if (this.state.paragraphId !== paragraphId) {
                    if (this.state.scrollContentFlag) {
                        const target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
                        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    }
                }
                this.setState({ currentTime, paragraphId });
            }
        };
        player.off('seeked', () => {
            console.debug('seeked canceled');
        });
        player.on('seeked', () => {
            const currentTime: number = player.currentTime,
                transcription = this.state.transcription;
            let paragraphId: string = '';
            if (transcription && transcription?.paragraphs && transcription?.paragraphs?.length) {
                const paragraphs = transcription?.paragraphs;
                for (const paragraph of paragraphs) {
                    if ((paragraph.start as number) <= currentTime * 1000 && (paragraph.end as number) >= currentTime * 1000) {
                        paragraphId = paragraph.paragraph_id || '';
                        break;
                    }
                }
                if (paragraphId) {
                    const target = document.querySelector('[data-paragraph-id="' + paragraphId + '"]');
                    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            }
        });
        player.on('end', () => {
            this.setState({ currentTime: 0, paragraphId: '' });
        });
    }

    initPlayer(player: any) {
        if (player) this.registerPlayerMethod(player);
    }

    removeKeyWordHandle(name: string, index: number) {
        const formData = this.state.formData,
            keyword = formData?.keyword;
        if (keyword?.del && keyword?.del?.length) keyword.del.push({ index, name });
        else keyword.del = [{ index, name }];
        keyword.all = keyword.all.filter((item) => item.index !== index);
        if (keyword?.add && keyword?.add.length) {
            keyword.add = keyword.add.filter((item) => item.index !== index);
        }
        this.setState({ formData });
    }

    randomKey: number = Math.floor(Math.random() * 1000);

    onPressEnterHandle(e: KeyboardEvent<HTMLInputElement>) {
        //@ts-ignore
        const value: string = e.target?.value,
            formData = this.state.formData,
            keyWords = formData?.keyword,
            all = keyWords.all,
            add = keyWords?.add;
        if (value) {
            let index = 1;
            if (all && all?.length) {
                let last = all[all.length - 1];
                index = last.index ? last.index + 1 : 1;
            }
            let item: KeywordTypeItem = { name: value, index };
            all.push(item);
            if (add && add?.length) add.push(item);
            else if (!add) keyWords.add = [item];
        }
        this.setState({ formData }, () => {
            //@ts-ignore
            e.target.value = '';
            this.randomKey = Math.floor(Math.random() * 1000);
        });
    }

    renderAIKeyWordHeader() {
        return (
            <div className={s['ai-key-word-header']}>
                <div className={s['ai-title']}><img src={img.datailtitle_icon} />关键字</div>
                {this.state.keywordsOverflow && (
                    <div className={s['ai-title-right']} onClick={this.toggleShowAllKeywords}>
                        {this.state.showAllKeywords ? <DownOutline style={{ fontSize: '14px', color: '#999999' }} /> : <RightOutline style={{ fontSize: '14px', color: '#999999' }} />}
                    </div>
                )}
            </div>
        );
    }

    toggleShowAllSummary = () => {
        this.setState({ showAllSummary: !this.state.showAllSummary });
    };

    renderAISummaryHeader() {
        return (
            <div className={s['ai-key-word-header']}>
                <div className={s['ai-title']}><img src={img.datailtitle_icon} />全文概要</div>
                {this.state.summarization?.paragraph_summary && this.state.summarization?.paragraph_summary?.length > 55 ?
                    <div className={s['ai-title-right']} onClick={this.toggleShowAllSummary}>
                        {this.state.showAllSummary ? <DownOutline style={{ fontSize: '14px', color: '#999999' }} /> : <RightOutline style={{ fontSize: '14px', color: '#999999' }} />}
                    </div> : null}
            </div>
        );
    }

    renderAIChapterHeader() {
        return (
            <div className={s['ai-key-word-header']}>
                <div className={s['ai-title']}><img src={img.datailtitle_icon} />章节速览</div>

                {/* 只有章节数 > 2 条时，才显示展开/收起 */}
                {(this.state.formData?.chapters?.length || 0) > 2 && (
                    <div className={s['ai-title-right']} onClick={() => this.viewChapter(this.state.activeCollapseKey)}>
                        {this.state.activeCollapseKey === '0' ?
                            <DownOutline style={{ fontSize: '14px', color: '#999999' }} />
                            :
                            <RightOutline style={{ fontSize: '14px', color: '#999999' }} />
                        }
                    </div>
                )}
            </div>
        );
    }

    renderAIRecapHeader() {
        return (
            <div className={s['ai-key-word-header']} style={{ margin: 0 }}>
                <div className={s['ai-title']}><img src={img.datailtitle_icon} />要点回顾</div>
                <div className={s['ai-title-right']}>
                    <div className={s['selBtn']} onClick={() => this.setState({ showStyleModal: true, selectedStyle: this.state.questionsAnsweringSummaryType })}>
                        {DEFAULT_OPTIONS.find(option => option.value === this.state.questionsAnsweringSummaryType)?.label || '选择风格'}<DownOutline style={{ color: '#999999', fontSize: '12px', marginLeft: '6px' }} />
                    </div>
                </div>

            </div>
        );
    }

    copyImg(file_url: string): Promise<ClipboardItem> {
        return new Promise((resolve) => {
            const canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'),
                img = new Image();
            canvas.width = 150;
            canvas.height = 85;
            img.crossOrigin = 'Anonymous';
            img.src = file_url;
            img.onload = () => {
                ctx?.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx?.drawImage(img, 0, 0);
                canvas.toBlob(async (blob) => {
                    //@ts-ignore
                    resolve(new ClipboardItem({ 'image/png': blob }));
                });
            };
        });
    }

    fadeToggle(fade: Fade) {
        if (fade === Fade.In) {
            const ele = document.querySelector('.ai-container');
            if (ele) ele.classList.add('fadeOut');
        } else if (fade === Fade.Out) {
            const ele = document.querySelector('.ai-container');
            if (ele) ele.classList.remove('fadeOut');
        }
        this.setState({ fade });
    }

    async fetchUpdateTitle(name: any) {
        return Request.put(Request.baseUrl + updateTitle + '/' + this.props.sourceId, {
            document_name: name
        });
    }

    async fetchTranslation(languages: any) {
        return Request.put(Request.baseUrl + getTranslation + '?document_id=' + this.props.sourceId + '&target_languages=' + languages);
    }

    async fetchGetDelete() {
        let arr = [this.props.sourceId];
        const data = await Request.delete(Request.baseUrl + getDelete, {
            document_ids: arr
        });
        return { data, success: true, code: '200', msg: '' };
    }

    handleEditClick = () => {
        this.setState({ isEditing: true }, () => {
            //@ts-ignore
            this.inputRef.current.focus();
        });
    };

    handleInputChange = (event: any) => {
        this.setState({ titleData: event.target.value });
    };
    handleBlur = () => {
        this.setState({ isEditing: false });
        if (!this.state.titleData || !this.state.titleData.trim()) {
            this.setState({ titleData: this.state.detail.name });
            return ToastUtils.showToast('请输入标题');
        }
        this.fetchUpdateTitle(this.state.titleData).then((res) => {
            //@ts-ignore
            if (res && !res?.success) {
                this.setState((prevState) => ({
                    detail: {
                        ...prevState.detail,
                        name: this.state.detail.name
                    },
                    titleData: this.state.detail.name
                }));
                //@ts-ignore
                ToastUtils.showToast(res?.msg || '服务请求发生错误');
            } else {
                //@ts-ignore
                this.setState((prevState) => ({
                    detail: {
                        ...prevState.detail,
                        name: this.state.titleData
                    }
                }));
                ToastUtils.showToast('操作成功');
            }
        });
    };

    handleSearch = (value: any) => {
        this.setState({ searchText: value });
    };

    onSearch = () => {
        this.clickKeyWords(this.state.searchText as string);
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        clearInterval(this.selectSummaryTimer as number);
        // 清理滚动监听
        const scrollEl = this.getActiveScrollEl();
        if (scrollEl) {
            scrollEl.removeEventListener('scroll', this.handleContentScroll);
        }
    }

    startTranslationStatusCheck = () => {
        this.getTranslationStatusLx();
        // @ts-ignore
        this.interval = window.setInterval(() => {
            this.getTranslationStatusLx();
        }, 5000);
    };
    getTranslationStatusLx = () => {
        this.getTranslationStatusFun().then((res) => {
            if (res && res.success) {
                //@ts-ignore
                this.setState({
                    translateStatus: Number(res?.data?.ai_translation_status),
                    languageValue: res?.data?.target_languages
                });
                //@ts-ignore
                if (res.data?.ai_translation_status === 2 || res.data?.ai_translation_status === 3) {
                    clearInterval(this.interval);
                    this.fetchData();
                }
            }
        });
    };
    handleLanguageValue = (val: string) => {
        this.setState({ translateLoading: true, translation: {} });
        this.fetchTranslation(val).then((res) => {
            //@ts-ignore
            if (res && res?.success) {
                ToastUtils.showToast('操作成功');
                this.setState({ languageValue: val, isTranslateShow: false, translateLoading: false });
                this.startTranslationStatusCheck();
            } else {
                //@ts-ignore
                ToastUtils.showToast(res.msg || '服务请求发生错误');
                this.setState({ translateLoading: false });
            }
        });
    };

    translateShowBtn = () => {
        this.setState({ showTranslateModal: true, tempLanguageValue: this.state.languageValue || 'no' });
    };

    returnBtn = () => {
        this.props.navigate(`/mobile/o/${this.props.paramsInfo?.agentId}/tools/${this.props.paramsInfo?.toolId}${searchString}`);
    };

    // Tab 切换时触发：如果切到原文，自动根据当前播放时间定位段落
    handleTabChange(key: string) {
        this.setState({ activeKey: key }, () => {
            // 切换到【原文】时，强制触发一次定位
            if (key === 'summaryAll') {
                this.scrollToCurrentPlayParagraph();
                const scrollEl = this.getActiveScrollEl();
                if (scrollEl) {
                    // 先清旧监听，避免重复
                    scrollEl.removeEventListener('scroll', this.handleContentScroll);
                    scrollEl.addEventListener('scroll', this.handleContentScroll);
                    // 手动触发一次，更新回到顶部按钮状态
                    this.handleContentScroll();
                }
            }
        });
    }

    // 根据当前视频播放时间，滚动到对应段落
    scrollToCurrentPlayParagraph() {
        const { currentTime, transcription } = this.state;
        if (!currentTime || !transcription?.paragraphs?.length) return;

        const currentMs = currentTime * 1000;
        let targetParagraphId = '';

        // 找到当前时间对应的段落
        transcription.paragraphs.forEach(p => {
            if (p.start! <= currentMs && currentMs <= p.end!) {
                targetParagraphId = p.paragraph_id!;
            }
        });

        // 滚动到目标段落
        if (targetParagraphId) {
            this.setState({ paragraphId: targetParagraphId }, () => {
                setTimeout(() => {
                    const target = document.querySelector(`[data-paragraph-id="${targetParagraphId}"]`);
                    target?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 100);
            });
        }
    }

    render() {
        //@ts-ignore
        return (
            <>
                <div className={s['ai-content-Itme']}>
                    <div className={s['ai-content-body']}>
                        {this.state.spin ? (
                            <div className={s['content-spin-loading']}>
                                <GrtLoading></GrtLoading>
                            </div>
                        ) : (
                            <>
                                <div className={s['ai-content-body-left']}>
                                    <div className={s['ai-content-body-header']}>
                                        <div className={s['ai-header-box']}>
                                            <div className={s['ai-content-body-header-title']}>
                                                <div className={s['outlinedBtn']} onClick={this.returnBtn.bind(this)}><img src={img.return_icon} /></div>
                                                <span className={s['nameText']} onClick={this.handleEditClick}>
                                                    {this.state.detail?.name}
                                                </span>

                                            </div>
                                            <div className={s['nameTip']}>内容由AI生成，仅供参考</div>

                                        </div>
                                    </div>
                                    <div className={`${s['ai-content-video']} ${this.state.fade === Fade.In ? s['hide'] : ''}`}>

                                        {
                                            //@ts-ignore
                                            this.state.detail?.type ? (
                                                <ViewSource
                                                    tokenUrl={Request.baseUrl + '/user/document/v1/vod/asset-token/'}
                                                    className={s['source-detail']}
                                                    detail={this.state.detail}
                                                    playerOptions={this.state.playerOptions}
                                                    initPlayer={this.initPlayer.bind(this)}
                                                />
                                            ) : null
                                        }
                                    </div>
                                    <div className={`${s['body_wrapper']} ${this.state.fade === Fade.In ? s['body_wrapperHide'] : ''}`}>
                                        <div className={s['ai-content-video-fade']}>
                                            {this.state.fade === Fade.In ? (
                                                <div className={s['ai-content-video-fade-btn']} onClick={() => this.fadeToggle(Fade.Out)}><img className={s['record_play']} src={img.record_play} />{this.state.detail.type === 2 ? '展开视频' : '展开音频'}<img src={img.foldUp_icon} alt={'展开'} /></div>
                                            ) : (
                                                <div className={s['ai-content-video-fade-btn']} onClick={() => this.fadeToggle(Fade.In)}>{this.state.detail.type === 2 ? '收起视频' : '收起音频'}<img className={s['foldUp_icon']} src={img.expand_icon} alt={'收起'} /></div>
                                            )}
                                        </div>
                                        <Tabs activeKey={this.state.activeKey} onChange={this.handleTabChange.bind(this)} >
                                            <Tabs.Tab title={<div className={s['tab-title']} style={{ color: this.state.activeKey === 'summary' ? '#3B70FF' : '#666666', fontWeight: this.state.activeKey === 'summary' ? '600' : 'normal' }}>智能速览<img src={img.titleAi_icon} alt={'智能速览'} /></div>} key='summary'>
                                                <div className={`${s['height-full']} ${this.state.fade === Fade.In ? s['height-full-hide'] : ''}`}>
                                                    {this.state.formData?.keyword?.all?.length > 0 ? (
                                                        <div className={`${s['ai-key-words']} ${s['backColor-class']}`}>
                                                            {this.renderAIKeyWordHeader()}
                                                            <div>{this.getKeyWords()}</div>
                                                        </div>
                                                    ) : null}
                                                    {this.state?.summarization?.paragraph_summary ? (
                                                        <div className={`${s['ai-summary']} ${s['backColor-class']}`}>
                                                            {this.renderAISummaryHeader()}
                                                            <div>{this.getSummary()}</div>
                                                        </div>
                                                    ) : null}
                                                    {this.state.tabItems?.length > 0 ? (
                                                        <div className={s['ai-tab-content']}>
                                                            {this.state.tabItems.map((item) => (
                                                                <div key={item.key} className={s['tab-item']}>
                                                                    {item.type === 'auto_chapters' && this.state.formData?.chapters?.length > 0 && (
                                                                        <>
                                                                            <div className={`${s['backColor-class']}`}>
                                                                                <div className={s['tab-item-title']}>{this.renderAIChapterHeader()}</div>
                                                                                <div className={s['item-content']}>{this.renderAutoChapters()}</div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {item.type === 'summarization' && this.state.formData?.conversational_summary_list?.length > 0 && (
                                                                        <>
                                                                            <div className={`${s['backColor-class']}`}>
                                                                                <div className={s['item-content']}>{this.renderSummarization()}</div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {item.type === 'questions_answering_summary_list' && this.state.formData?.questions_answering_summary_list?.length > 0 && (
                                                                        <>
                                                                            <div className={`${s['backColor-class']}`}>
                                                                                <div className={s['tab-item-title']}>{this.renderAIRecapHeader()}</div>
                                                                                <div className={s['item-content']}>{this.renderQuestionsAnsweringSummary()}</div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>

                                                    ) : null}
                                                    {!this.state.formData?.keyword?.all?.length && !this.state?.summarization?.paragraph_summary && !this.state.formData?.chapters?.length && !this.state.formData?.conversational_summary_list?.length && !this.state.formData?.questions_answering_summary_list?.length ?
                                                        <div className={s['status-div']}>
                                                            <img src={emptyImg} />
                                                            <div className={s['status-text']}>
                                                                抱歉，暂无数据～
                                                            </div>
                                                        </div> : null
                                                    }
                                                </div>
                                            </Tabs.Tab>
                                            <Tabs.Tab className='tab-summaryAll' title={<div className={s['tab-title']} style={{ color: this.state.activeKey === 'summaryAll' ? '#3B70FF' : '#666666', fontWeight: this.state.activeKey === 'summaryAll' ? '600' : 'normal' }}>原文</div>} key='summaryAll'>
                                                <div className={`${s['height-full']} ${this.state.fade === Fade.In ? s['height-full-hide'] : ''}`}>
                                                    {this.state.transcription.paragraphs?.length ?
                                                        <div className={s['ai-header-search']}>
                                                            <div className={`${s['search-container']} ${this.state.isRealTime ? s['search-container-realTime'] : ''}`}>
                                                                <img src={img.search_icon} onClick={this.onSearch.bind(this)} />
                                                                <Input
                                                                    className={s['searchInput']}
                                                                    placeholder="请输入关键字"
                                                                    maxLength={50}
                                                                    onChange={this.handleSearch.bind(this)}
                                                                    value={this.state.searchText}
                                                                    clearable={true}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            this.onSearch();
                                                                        }
                                                                    }}
                                                                    onClear={() => { this.setState({ searchText: '', currKeyWord: '' }); this.clickKeyWords(''); }}
                                                                    style={{ '--border-radius': '4px' } as any}
                                                                />
                                                            </div>
                                                            {this.state.translateStatus === 1 ? (
                                                                <div style={{ display: 'flex', alignItems: 'center', width: '35px', height: '35px', marginLeft: '15px', backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '8px', boxSizing: 'border-box', justifyContent: 'center' }}><SpinLoading style={{ '--size': '14px', '--color': '#3b70ff', width: '14px', height: '14px' }} /></div>
                                                            ) : this.state.isRealTime ? null : (
                                                                <div className={s['ai-header-tran']}>
                                                                    <div className={s['translatioItem']} onClick={this.translateShowBtn.bind(this)}>
                                                                        {this.state.translateStatus === 2 && this.state.languageValue !== 'no' ? <img src={img.translationCur_icon} /> : <img src={img.translation_icon} />}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <ModalPopup
                                                                visible={this.state.showTranslateModal || false}
                                                                title="翻译"
                                                                onClose={() => this.setState({ showTranslateModal: false })}
                                                            >

                                                                <div className={s['selector-lsit']}>
                                                                    <Selector
                                                                        showCheckMark={false}
                                                                        columns={1}
                                                                        value={[this.state.tempLanguageValue || 'no']}
                                                                        onChange={(val) => val.length && this.setState({ tempLanguageValue: val[0] })}
                                                                        options={languageOptionsInfo}
                                                                        multiple={false}
                                                                        disabled={false}
                                                                    />
                                                                </div>
                                                                <div className={s['btn-css']}>
                                                                    <Button size='small' color='primary' className={s['btn-primary']}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                languageValue: this.state.tempLanguageValue || 'no',
                                                                                translateStatus: 1
                                                                            });
                                                                            this.handleLanguageValue(this.state.tempLanguageValue || 'no');
                                                                            this.setState({ showTranslateModal: false });
                                                                        }}
                                                                    >
                                                                        确定
                                                                    </Button>
                                                                </div>
                                                            </ModalPopup>
                                                        </div> : null}
                                                    <div className={`${s['ai-summary-all']}`}>
                                                        <div className={s['ai-summary-all-content']}>{this.getAllContent()}</div>
                                                    </div>
                                                    <div className={s['side-tool']}>
                                                        {this.state.transcription.paragraphs?.length ?
                                                            <div className={s['tool-top-curr']}>
                                                                <img src={img.aimOutlined_icon} onClick={this.scroll2View.bind(this)} className={s['side-tool-icon']} />
                                                                {this.state.ishowBackTop > 10 && (
                                                                    <img src={img.topCurr_icon} onClick={this.scroll2Top.bind(this)} className={s['side-tool-icon']} />)}
                                                            </div> : null}
                                                    </div>
                                                </div>
                                            </Tabs.Tab>
                                        </Tabs>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {this.state.photoImages?.length ? (
                    <PhotoSlider
                        images={this.state.photoImages.map((item) => ({ src: item.src, key: item.key })) as any}
                        visible={this.state.showPhoto as boolean}
                        onClose={() => this.setState({ showPhoto: false })}
                        index={this.state.photoIndex as number}
                        onIndexChange={(index) => this.setState({ photoIndex: index })}
                    />
                ) : null}
            </>
        );
    }
}

const App = (props: any) => {
    const { grtAi } = props.store;
    const paramsInfo = useParams(),
        paramsId = paramsInfo.toolDetail as string,
        [searchParams] = useSearchParams();
    const [isCheckCanUse, setIsCheckCanUse] = useState(false);
    const [isToolTw, setIsToolTw] = useState(false);
    const navigate = useNavigate();
    const goLogin = () => {
        let redirect = `${window.location.href}`;
        window.location.href = `${origin}/mobile/login?redirect=${redirect}`;
    };
    const checkIsLogin = async () => {
        const res = await grtAi.checkLogin();
        if (res) {
            return true;
        }
        ToastUtils.showToast('请登录');
        setTimeout(() => {
            goLogin();
        }, 500);
        return false;
    };
    const checkCanUseFun = async () => {
        const res = await grtAi.checkCanUseStudy(paramsInfo.agentId);
        if (!res || !res.success || !res.data) {
            ToastUtils.showToast('该智能体未对外开放使用，请联系管理员');
            setIsCheckCanUse(true);
        }
    };
    useEffect(() => {
        const toolData = grtAi?.state?.currentAgent?.scene_tool;
        if (toolData && toolData.length > 0) {
            // @ts-ignore
            const exists = toolData.some((tool) => tool.tool_id === 1 || tool.tool_id === '1');

            if (!exists) {
                ToastUtils.showToast('该智能体未对外开放使用，请联系管理员');
                return setIsToolTw(true);
            }
            setIsToolTw(false);
        } else {
            setIsToolTw(true);
            ToastUtils.showToast('该智能体未对外开放使用，请联系管理员');
        }
        checkIsLogin();
        checkCanUseFun();
    }, []);
    return (
        <>
            <div className={s['wrapper']} style={{ width: '100%' }}>
                <Display show={isCheckCanUse || isToolTw}>
                    <div className={s['isCheckCanUse']}></div>
                </Display>
                <SourceDetailAI key={paramsId} sourceId={paramsId} paramsInfo={paramsInfo} searchParams={searchParams} navigate={navigate} />
            </div>
        </>
    );
};
export default withRouter(inject('store')(observer(App)));